import { motion } from "framer-motion";
import { Brain, Workflow, Database, Cloud } from "lucide-react";

const horizons = [
  {
    icon: Database,
    title: "Vertical AI Platforms",
    desc: "Industry-specific AI systems tailored for restaurants, finance, retail, and operations. We deliver AI-driven decision support, intelligent forecasting, and autonomous workflow automation designed for measurable operational impact.",
  },
  {
    icon: Workflow,
    title: "AI Agents & Automation",
    desc: "Autonomous digital workers seamlessly integrated into your workflows. From task automation and document processing to multi-step decision pipelines and AI copilots, we enhance productivity at scale.",
  },
  {
    icon: Brain,
    title: "Intelligent SaaS Platforms",
    desc: "Cloud-native SaaS products built with AI at their core. Featuring AI-powered dashboards, predictive analytics, real-time insights, and API-first architecture for scalable innovation.",
  },
  {
    icon: Cloud,
    title: "Enterprise Digital Transformation",
    desc: "Modernizing legacy systems through architecture redesign, cloud migration, AI integration strategies, and performance optimization to unlock long-term enterprise value.",
  },
];

const SolutionsSection = () => {
  return (
    <section id="solutions" className="py-24 md:py-32">
      <div className="container px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <p className="text-sm uppercase tracking-[0.2em] text-primary mb-3 font-body">
            AI Solutions Designed for Real-World Impact
          </p>
          <h2 className="text-3xl md:text-5xl font-bold font-display">
            Intelligent <span className="text-gradient-red">Solutions</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
          {horizons.map((h, i) => (
            <motion.div
              key={h.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="group p-8 rounded-xl bg-card border border-glass hover:border-primary/30 transition-all duration-500 shadow-card"
            >
              <div className="w-12 h-12 rounded-lg bg-gradient-red flex items-center justify-center mb-5">
                <h.icon className="w-6 h-6 text-primary-foreground" />
              </div>
              <h3 className="text-xl font-display font-semibold mb-3 text-foreground">
                {h.title}
              </h3>
              <p className="text-muted-foreground text-sm leading-relaxed font-body">
                {h.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SolutionsSection;